import React from 'react';
import { Container, Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import { COLORS } from '../theme/tibiaTheme';

function ApiDownPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container maxWidth="xl" sx={{ px: isMobile ? 1 : 3 }}>
      {/* Header da página */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant={isMobile ? "h4" : "h3"} sx={{
          color: COLORS.onSurface,
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
          mb: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2
        }}>
          Erro ao carregar a página
        </Typography>
      </Box>

      {/* Mensagem principal */}
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        textAlign: 'center',
        p: 4,
      }}>
        <Box sx={{ mb: 2 }}>
          <Typography sx={{
            fontFamily: 'Tahoma, Arial, sans-serif',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#ffff4d',
            textShadow: '1px 0px 0px black, -1px 0px 0px black, 0px 1px 0px black, 0px -1px 0px black',
            mb: 0.5
          }}>
            Gamemaster says:
          </Typography>
          <Typography sx={{
            fontFamily: 'Tahoma, Arial, sans-serif',
            fontSize: '13px',
            fontWeight: 'bold',
            color: '#ffff4d',
            textShadow: '1px 0px 0px black, -1px 0px 0px black, 0px 1px 0px black, 0px -1px 0px black'
          }}>
            Sorry for the inconvenience!
          </Typography>
        </Box>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/gamemaster.png`}
          alt="Gamemaster"
          sx={{
            width: '180px',
            height: '180px',
            imageRendering: 'pixelated',
            filter: 'drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.5))'
          }}
        />
      </Box>
    </Container>
  );
}

export default ApiDownPage;